"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchRow = void 0;
var tablecells_1 = require("./tablecells");
var columns_1 = require("./columns");
function dispatchRow(row) {
    var fields = [];
    row.fields.map(function (field) {
        switch (field.column) {
            case columns_1.RiskColumnIds.BIM_LOCATIONS:
            case columns_1.ControlColumnIds.BIM_LOCATIONS:
                fields.push(new tablecells_1.BimLocationsTableCell(field.id, field.data, field.display, field.column));
                break;
            case columns_1.RiskColumnIds.CATEGORY:
            case columns_1.ControlColumnIds.CATEGORY:
            case columns_1.ActionColumnIds.CATEGORY:
            case columns_1.RiskColumnIds.CONFIDENTIAL:
                fields.push(new tablecells_1.CheckboxesTableCell(field.id, field.data, field.display, field.column));
                break;
            case columns_1.RiskColumnIds.EVALUATION:
                fields.push(new tablecells_1.EvaluationTableCell(field.id, field.data, field.display, field.column));
                break;
            case columns_1.RiskColumnIds.CAUSE:
            case columns_1.RiskColumnIds.EFFECT:
                fields.push(new tablecells_1.CausalityTableCell(field.id, field.data, field.display, field.column));
                break;
            case columns_1.RiskColumnIds.REFERENCES:
            case columns_1.ControlColumnIds.REFERENCES:
            case columns_1.ActionColumnIds.REFERENCES:
                fields.push(new tablecells_1.ReferenceTableCell(field.id, field.data, field.display, field.column));
                break;
            case columns_1.RiskColumnIds.RISK_NUMBER:
            case columns_1.RiskColumnIds.LAST_MODIFIED:
            case columns_1.RiskColumnIds.NOTES:
            case columns_1.RiskColumnIds.DESCRIPTION:
            case columns_1.RiskColumnIds.STATUS:
            case columns_1.RiskColumnIds.TITLE:
            case columns_1.RiskColumnIds.REVIEWED_AT:
            case columns_1.RiskColumnIds.REVIEWED_BY:
            case columns_1.ControlColumnIds.CONTROL_NUMBER:
            case columns_1.ControlColumnIds.LAST_MODIFIED:
            case columns_1.ControlColumnIds.STATUS:
            case columns_1.ControlColumnIds.TITLE:
            case columns_1.ControlColumnIds.CONFIDENTIAL:
            case columns_1.ActionColumnIds.ACTION_NUMBER:
            case columns_1.ActionColumnIds.LAST_MODIFIED:
            case columns_1.ActionColumnIds.STATUS:
            case columns_1.ActionColumnIds.TITLE:
            case columns_1.ActionColumnIds.CONFIDENTIAL:
            case columns_1.CausalityColumnIds.NUMBER:
            case columns_1.CausalityColumnIds.TEXT:
            case columns_1.CausalityColumnIds.CONFIDENTIAL:
            case columns_1.OverviewTablesColumnIds.RISK_OWNER:
            case columns_1.OverviewTablesColumnIds.CONTROL_OWNER:
            case columns_1.OverviewTablesColumnIds.ACTION_OWNER:
            case columns_1.OverviewTablesColumnIds.STATUS_DISPLAY:
            case columns_1.OverviewTablesColumnIds.EVALUATION_OWNER:
            case columns_1.OverviewTablesColumnIds.EVALUATION_TITLE:
            case columns_1.OverviewTablesColumnIds.EVALUATION_STATUS:
            case columns_1.RiskColumnIds.OWNER:
            case columns_1.ControlColumnIds.OWNER:
            case columns_1.ActionColumnIds.OWNER:
                fields.push(new tablecells_1.OwnerTableCell(field.id, field.data, field.display, field.column));
                break;
            case columns_1.RiskColumnIds.WORST_RISK:
                fields.push(new tablecells_1.WorstRiskTableCell(field.id, field.data, field.display, field.column));
                break;
            case columns_1.RiskColumnIds.BEST_RISK:
                fields.push(new tablecells_1.BestRiskTableCell(field.id, field.data, field.display, field.column));
                break;
            case columns_1.ControlColumnIds.RISK_RELATIONS:
            case columns_1.CausalityColumnIds.RISK_RELATIONS:
            case columns_1.CausalityColumnIds.CONTROL_RELATIONS:
            case columns_1.RiskColumnIds.CONTROLS:
            case columns_1.ControlColumnIds.CAUSE_RELATIONS:
            case columns_1.ControlColumnIds.EFFECT_RELATIONS:
                fields.push(new tablecells_1.LinksTableCell(field.id, field.data, field.display, field.column));
                break;
            case columns_1.ControlColumnIds.DEADLINE:
            case columns_1.ActionColumnIds.DEADLINE:
                fields.push(new tablecells_1.DeadlineTableCell(field.id, field.data, field.display, field.column));
                break;
            case columns_1.ControlColumnIds.CONTROL_COST:
                fields.push(new tablecells_1.MeasurementTableCell(field.id, field.data, field.display, field.column));
                break;
            case columns_1.RiskColumnIds.USERDEFINED:
            case columns_1.ControlColumnIds.USERDEFINED:
            case columns_1.CausalityColumnIds.USERDEFINED:
                fields.push(new tablecells_1.TableCell(field.id, field.data, field.display, field.column, field.user_field_id));
                break;
            default:
                fields.push(new tablecells_1.TableCell(field.id, field.data, field.display, field.column));
        }
    });
    return {
        fields: fields,
        id: row.id,
        url: row.url,
        group_key: row.group_key,
    };
}
exports.dispatchRow = dispatchRow;
